import { Country } from '@app/models';
import { Action } from '@ngrx/store';

export enum CountriesActionTypes {
  FetchCountries = '[Countries] Fetch Countries',
  FetchCountriesSuccess = '[Countries] Fetch Countries Success',
  FetchCountriesFail = '[Countries] Fetch Countries Fail'
}

export class FetchCountries implements Action {
  readonly type = CountriesActionTypes.FetchCountries;
}

export class FetchCountriesSuccess implements Action {
  readonly type = CountriesActionTypes.FetchCountriesSuccess;

  constructor(public payload: Country[]) {
  }
}

export class FetchCountriesFail implements Action {
  readonly type = CountriesActionTypes.FetchCountriesFail;

  constructor(public payload: Error) {
  }
}

export type CountriesActions =
  | FetchCountries
  | FetchCountriesSuccess
  | FetchCountriesFail;
